import React from "react";

const EvaluationStepper = ({ currentStepIndex }) => {
  const steps = [
    { number: 1, label: "القراءة" },
    { number: 2, label: "الأسئلة" },
    { number: 3, label: "النتائج" },
  ];

  return (
    <div
      className="d-flex align-items-center justify-content-center gap-3 py-3 bg-white border-bottom sticky-top"
      style={{ zIndex: 1020, direction: "rtl" }}
    >
      {steps.map((step, idx) => {
        const isActive = currentStepIndex >= idx;
        const color = isActive ? "#25accf" : "#cbd5e1";

        return (
          <React.Fragment key={step.number}>
            {idx > 0 && (
              <div
                className="d-flex align-items-center justify-content-center text-muted px-1"
                style={{ color: "#25accf", fontSize: "18px", fontWeight: "bold" }}
              >
                ⟵
              </div>
            )}
            <div
              className="d-flex align-items-center gap-2"
              style={{ color, fontWeight: "bold", fontSize: "18px" }}
            >
              <span
                className="d-flex align-items-center justify-content-center rounded-circle border"
                style={{
                  width: "34px",
                  height: "34px",
                  borderColor: color,
                  color: color,
                  backgroundColor: "#ffffff",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                {step.number}
              </span>
              <span>{step.label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default EvaluationStepper;
